import VerifyOTPTemplate from "templates/auth/verifyOTP";

export default function VerifyOTPPage() {
  return (
    <>
      <VerifyOTPTemplate />
    </>
  );
}
